"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_ICON_MOBILE = exports.USER_ICON_DESKTOP = exports.MY_PAGES_URL = void 0;
const USER_ICON_MOBILE = exports.USER_ICON_MOBILE = 'user-icon-mobile';
const USER_ICON_DESKTOP = exports.USER_ICON_DESKTOP = 'user-icon-desktop';
const MY_PAGES_URL = exports.MY_PAGES_URL = '/ssoidentity/mypages';